<div class="collapse-icon">
  <div class="collapse-default">
    <div class="card">
      <div class="card-header p-0">
        <button class="row collapse-title btn p-0"
                title="Expand {{category.name}}"
                (click)="isCollapsed = !isCollapsed"
                [attr.aria-expanded]="!isCollapsed"
                aria-controls="collapseExample"
                data-toggle="collapse"
                role="button">
        </button>
        <div class="filter-check">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" [(ngModel)]="categorySelection[category.id]" [id]="'checkbox-' + category.id"  (change)="updateParent()"/>
            <label class="custom-control-label" [for]="'checkbox-' + category.id"></label>
          </div>
          <label [for]="'checkbox-' + category.id" class="filter-details">
            <div class="title" placement="auto"
                 ngbTooltip="{{ category.name }}">
              {{ category.name }}
            </div>
          </label>
        </div>
      </div>

      <div [ngbCollapse]="isCollapsed" id="collapseExample">
        <div class="card">
          <div class="card-body">
            <div class="categories-list">
              <div class="category-item"
                   *ngFor="let subCategory of category.children">
                <div class="filter-check">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="categorySelection[subCategory.id]" [id]="'checkbox-' + subCategory.id"  (change)="updateParent()"/>
                    <label class="custom-control-label" [for]="'checkbox-' + subCategory.id"></label>
                  </div>
                  <label [for]="'checkbox-' + subCategory.id" class="filter-details">
                    <div class="title" placement="auto"
                         ngbTooltip="{{ subCategory.name }}">
                      {{ subCategory.name }}
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
